import React from "react";
import styled from "styled-components";
import { style } from "../style";
import { BillingItemizedSummary } from "./BillingItemizedSummary";
import { BillingItemizedSummaryLineItem } from "./types";

type ExpandableProps = {
  items: BillingItemizedSummaryLineItem[];
  primaryUnit?: "monthly" | "hourly";

  expandable: true;
  expanded: boolean;
  onToggleExpanded(): void;
};

type NonExpandableProps = {
  items: BillingItemizedSummaryLineItem[];
  primaryUnit?: "monthly" | "hourly";

  expandable?: false;
  expanded?: never;
  onToggleExpanded?: never;
};

type Props = ExpandableProps | NonExpandableProps;

const Container = styled.div`
  box-sizing: border-box;
  padding-bottom: ${style.vars.space[4]};

  background: ${style.colors.shadesOfGrey[1]};
  border: 1px solid ${style.colors.grey.primary};
  border-radius: ${style.vars.borderRadius.base};
`;

export const BillingSection: React.FC<Props> = (props) => {
  if (props.expandable) {
    return (
      <Container>
        <BillingItemizedSummary
          items={props.items}
          primaryUnit={props.primaryUnit}
          expandable={props.expandable}
          expanded={props.expanded}
          onToggleExpanded={props.onToggleExpanded}
        />
      </Container>
    );
  } else {
    return (
      <Container>
        <BillingItemizedSummary items={props.items} primaryUnit={props.primaryUnit} />
      </Container>
    );
  }
};
